import { MealCountDtoViewModel } from "@/view-models";
import { MealCountDto, ReceivedMeals, ServingLine, ProgramType, MealCountCalcs } from '@/models';
import { Guid } from 'guid-typescript';
import moment from "moment";

let date = moment.utc().format();
let testReceivedMeals = new ReceivedMeals('2020-02-10', 1, 100, 0, 0, 1, 'Test', 'User', date, date);
let testServingLine = new ServingLine(Guid.create().toString(), 1, 1, 1, 1, 1, 1, 1, 1, 0, true, 1, 'Test', 'User', date, date);

let testCounts = new MealCountDto(
    Guid.create().toString(),
    8,
    ProgramType.SFSP,
    'LUNCH',
    '2020-02-14',
    date,
    false,
    0,
    testReceivedMeals,
    [ testServingLine ]);

let calcCounts = new MealCountCalcs(testCounts);

let model = new MealCountDtoViewModel(testCounts);

export let data = {
    testReceiveCounts: testReceivedMeals,
    testServeCounts: testServingLine,
    testCounts: testCounts,
    calcCounts: calcCounts,
    model: model
}
